import { makeActionCreator } from 'service/utility';

export const SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
export const setAccessToken = makeActionCreator(SET_ACCESS_TOKEN, 'accessToken');

export const REMOVE_ACCESS_TOKEN = 'REMOVE_ACCESS_TOKEN';
export const removeAccessToken = makeActionCreator(REMOVE_ACCESS_TOKEN);

export const SET_EMPRESA = 'SET_EMPRESA';
export const setEmpresa = makeActionCreator(SET_EMPRESA, 'empresa');

export const SET_USUARIO = 'SET_USUARIO';
export const setUsuario = makeActionCreator(SET_USUARIO, 'usuario');

export const REMOVE_USUARIO = 'REMOVE_USUARIO';
export const removeUsuario = makeActionCreator(REMOVE_USUARIO);

export const SIDE_MENU_OPEN = 'SIDE_MENU_OPEN';
export const openSideMenu = makeActionCreator(SIDE_MENU_OPEN, 'sideMenuOpen')

export const SET_PEDIDO = 'SET_PEDIDO';
export const setPedido = makeActionCreator(SET_PEDIDO, 'pedido');